module.exports = __webpack_public_path__ + "images/energy-label-water-a-xl.14e8bb.svg";